import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';

// Unity build cache worker: pins loader/framework/wasm in the Cache API (the
// browser HTTP cache kept evicting the 7 MB wasm between visits) and coalesces
// concurrent identical build fetches (warm fetch + Unity loader). Scoped to
// cdn CDN Build/* URLs only — it never touches app or API traffic.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/unity-cache-sw.js').catch(() => {
      /* SW is an optimization — never block the app on it */
    });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);
